import { useState, useRef } from "react";
import { GrAddCircle } from "@react-icons/all-files/gr/GrAddCircle";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";

function AddTodoForm() {
    const dispatch = useDispatch();

    const descriptionInputId = "formDescriptionInput1";

    const todaysDate = new Date().toISOString().split("T")[0];
    const chosenMaxDate = "2030-01-01";

    const [nameInput, setNameInput] = useState("");
    const [descriptionInput, setDescriptionInput] = useState("");
    const [startDateInput, setStartDateInput] = useState(todaysDate);
    const [endDateInput, setEndDateInput] = useState(todaysDate);
    const completedInput = false; // todo checked as completed
    const editModeInput = false; // todo checked to be edited
    const viewStateInput = true; // todo that has been cleared and cant be altered

    const startDateEl = useRef("");
    const endDateEl = useRef("");

    const submitButton = useRef();

    const startMinDate = todaysDate;
    const startMaxDate = chosenMaxDate;
    const endMinDate = todaysDate;
    const endMaxDate = chosenMaxDate;

    const onSubmit = (e) => {
        e.preventDefault();
        if (nameInput === "") return;

        const defaultDescriptionInput =
            descriptionInput === "" ? "No description given" : descriptionInput;
        const defaultStartDateInput =
            startDateInput === ""
                ? new Date().toISOString().substring(0, 10)
                : startDateInput;
        const defaultEndDateInput =
            endDateInput === ""
                ? new Date().toISOString().substring(0, 10)
                : endDateInput;
        setDescriptionInput(defaultDescriptionInput);
        setStartDateInput(defaultStartDateInput);
        setEndDateInput(defaultEndDateInput);

        const newTodo = {
            id: uuidv4(),
            name: nameInput,
            description: defaultDescriptionInput,
            startDate: defaultStartDateInput,
            endDate: defaultEndDateInput,
            completed: completedInput,
            editMode: editModeInput,
            viewState: viewStateInput,
        };
        dispatch({ type: "ADD_TODO", payload: { newTodo } });
        setNameInput("");
        setDescriptionInput("");
        setStartDateInput(todaysDate);
        setEndDateInput(todaysDate);

        submitButton.current.classList.add('pulse-active');
        setTimeout(()=>submitButton.current.classList.remove('pulse-active'),350*2);
    };

    const handleStartDateSetter = (e) => {
        // ensures start date and end date dont overlap in the wrong direction
        if (e.target.value > endDateEl.current.value)
            setEndDateInput(e.target.value);
        setStartDateInput(e.target.value);
    };

    const handleEndDateSetter = (e) => {
        // ensures start date and end date dont overlap in the wrong direction
        if (e.target.value < startDateEl.current.value)
            setStartDateInput(e.target.value);
        setEndDateInput(e.target.value);
    };

    return (
        <form onSubmit={onSubmit} className="add-todo-form">
            <div className="controls-header">Add a new item</div>
            <div className="controls-wrapper">
                <div className="todo input">
                    <div className="todo-content">
                        <div>
                            <div>
                                <label htmlFor="taskName1" className="">
                                    Task name
                                </label>
                            </div>
                            <input
                                id="taskName1"
                                type="text"
                                // placeholder="my first task"
                                value={nameInput}
                                onChange={(e) => {
                                    setNameInput(e.target.value);
                                }}
                                required
                            />
                        </div>
                        <div>
                            <div>
                                <label
                                    htmlFor={descriptionInputId}
                                    className=""
                                >
                                    Description
                                </label>
                            </div>
                            <textarea
                                id={descriptionInputId}
                                type="textarea"
                                // placeholder="No description given"
                                value={descriptionInput}
                                onChange={(e) => {
                                    setDescriptionInput(e.target.value);
                                }}
                            />
                        </div>
                        <div>
                            <div>
                                <label htmlFor="start-date">From:</label>
                            </div>
                            <div>
                                <input
                                    ref={startDateEl}
                                    id="start-date"
                                    type="date"
                                    min={startMinDate}
                                    max={startMaxDate}
                                    value={startDateInput}
                                    onChange={handleStartDateSetter}
                                />
                            </div>
                        </div>
                        <div>
                            <div>
                                <label htmlFor="end-date">To:</label>
                            </div>
                            <div>
                                <input
                                    ref={endDateEl}
                                    id="end-date"
                                    type="date"
                                    min={endMinDate}
                                    max={endMaxDate}
                                    value={endDateInput}
                                    onChange={handleEndDateSetter}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button
                ref={submitButton}
                type="submit"
                title="Add a new task to your list"
                className="btn-type-1"
            >
                <GrAddCircle />
                Add task
            </button>
        </form>
    );
}

export default AddTodoForm;
